import { Component, OnInit } from "@angular/core";
import { PTService } from "../pt.service";
import { PTLight } from "../models/pt.light.model";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { APP_SETTINGS } from "src/environments/environment";

@Component({
  selector: "app-lista-pt",
  templateUrl: "./lista-pt.component.html",
})
export class ListaPTComponent implements OnInit {
  constructor(
    private ptService: PTService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  pts: PTLight[] = undefined;
  voids: string[] = [];
  maximoLinhas: number = 9;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  ngOnInit() {
    this.ptService.getPTsStatusAberto().subscribe(
      (response: PTLight[]) => {
        this.pts = response;
        this.setVoids();
      },
      (err: any) => {
        this.toastr.error(
          "Erro ao tentar obter a lista de PT com status aberto"
        );
      }
    );
  }

  editar(id: number) {
    this.router.navigate([`solicitar-pt/cadastrar/${id}`]);
  }

  private setVoids() {
    this.voids = [];

    if (this.pts.length < this.maximoLinhas) {
      for (let i = this.pts.length; i < this.maximoLinhas; i++) {
        this.voids.push("");
      }
    }
  }
}
